// import React, { useState } from 'react';
// import { Box } from '@mui/material';
// import Sidebar from '../../../Seller/Sidebar';
// import ProfileMain from '../Profile/ProfileMain';
// import ProfileViewed from '../Profile/ProfileViewed';

// const ProfileViewMain = () => {
//   const [showViewed, setShowViewed] = useState(true);

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         minHeight: '100vh',
//         backgroundColor: '#F9FAFB',
//         flexDirection: { xs: 'column', md: 'row' },
//         mt: { xs: '64px', md: '15px' }, 
//       }}
//     >
//       <Sidebar/>
//       <Box
//         sx={{
//           flex: 1,
//           display: 'flex',
//           flexDirection: 'column',
//           minWidth: 0,
//           boxSizing: 'border-box',
//           // ✅ Use same margins as ProfileContent:
//           ml: { xs: 0, md: '25px' },
//           mr: { xs: 0, md: '80px' },
//           pt: { xs: '16px', md: '32px' },
//           pb: { xs: '16px', md: '32px' },
          
//         }}
//       >
//         <Box sx={{ mt: { xs: 0, md: '2px' } }}>
//           <ProfileMain />
//         </Box>

//         {showViewed && <ProfileViewed />}
//       </Box>
//     </Box>
//   );
// };

// export default ProfileViewMain;


import React, { useState } from 'react';
import { Box, useMediaQuery, useTheme } from '@mui/material';
import Sidebar from '../../../Seller/Sidebar';
import ProfileMain from '../Profile/ProfileMain';
import ProfileViewed from '../Profile/ProfileViewed';

const ProfileViewMain = () => {
  const [showViewed, setShowViewed] = useState(true);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: '100vh',
        backgroundColor: '#F9FAFB',
        flexDirection: { xs: 'column', md: 'row' },
        mt: { xs: '64px', md: '15px' }, 
      }}
    >
      {/* ✅ Hide Sidebar on mobile */}
      {!isMobile && <Sidebar />}
      
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minWidth: 0,
          boxSizing: 'border-box',
          ml: { xs: 0, md: '25px' },
          mr: { xs: 0, md: '80px' },
          pt: { xs: '16px', md: '32px' },
          pb: { xs: '16px', md: '32px' },
        }}
      >
        <Box sx={{ mt: { xs: 0, md: '2px' } }}>
          <ProfileMain />
        </Box>

        {showViewed && <ProfileViewed />}
      </Box>
    </Box>
  );
};

export default ProfileViewMain;
